// src/middleware/log.js
export default function log({ next, to }) {
  
    return next();
  }